// src/components/AuthContainer.jsx
import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import './authContainer.css'; // optional CSS file if you want styling
import Nav from '../containers/Home/Nav';
import googleIcon from '../assets/icon/google.svg'; // Assuming you have a Google icon
function AuthContainer() {
  // State to toggle which form is displayed
  const [showLogin, setShowLogin] = useState(true);
  const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || window.location.origin;



  return (
    <div dir="rtl">
      <Nav />
      <div className="auth-container">

        <div className="form-section">
          {showLogin ? <LoginForm /> : <RegisterForm />}
        </div>
        <div className="toggle-buttons">
            {/* <a
              className="google-login"
              href={`${process.env.REACT_APP_API_URL}auth/login/google-oauth2/`}


              > */}
              {/* <img src={googleIcon} alt="Google" />
              تسجيل الدخول عبر جوجل
            </a> */}
          <button
            className={`login-link ${showLogin ? 'active' : ''}`}
            onClick={() => setShowLogin(true)}
          >
              لديك حساب؟
          </button>
          <button
            className={`reqister-link ${!showLogin ? 'active' : ''}`}
            onClick={() => setShowLogin(false)}
          >
            ليس لديك حساب؟
          </button>
        </div>
      </div>

    </div>
  );
}

export default AuthContainer;
